import React from 'react';
import '../profile.css';
import axios from 'axios';
// import { PayPalButton } from "react-paypal-button-v2";
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
const queryString = require('query-string');


function getStudent(studentEmail){
    var myParam = {
        email: studentEmail
    }
  
    axios.post("https://auxilliabackend.herokuapp.com/getStudentProfile",myParam)
    .then(function (response) {
      
      const data = response.data;
      console.log(data);

      window.studentProf.addStudentToState(data.Email,data.Name, data.Paypal);  
      return data;
  
  
      //window.location.reload(true);
    })
    .catch(function (error) {
      console.log(error);
    });
  }


  



//Functional Component 
class studentProfilePage extends React.Component{
    constructor(props)
    {
        super(props);
        window.studentProf = this;
        this.state = {
        email:"",
        name:"",
        paypal:""
        }
    }

    componentDidMount()
    {
        //const mail = queryString.parse(window.location.search).email;
        const mail = localStorage.getItem('email');
        getStudent(mail);
    }

    addStudentToState(email,name,paypal)
    {
        this.setState({
            email:email,
            name:name,
            paypal:paypal
        });
        
    }

    handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }


    // reroute(){
    //     getZoom("CSCEC",this.state.comments);
    //     this.props.history.push({pathname: '/reserve'});
    // }
    
    render()
    {
        return (
            <div className="App">
                <body className = "profile-body">

                    {/* user banner */}
                    <div class = "profileBanner">
                        <div class = "profileName"> {/* The name at the top */}
                            <h3>{this.state.name}</h3>
                        </div>

                        <div class = "profileInfoData"> {/* This is under the name and where all the info goes should be an inline block*/}
                            <div class = "InfoData">
                                <h4>Email</h4>
                                <p>{this.state.email}</p>
                            </div>

                            <div class = "InfoData">
                                <h4>PayPal Email</h4>
                                <p>{this.state.paypal}</p>
                            </div>
                        </div>
                    </div>
                </body>
            </div>
        );
    }
  }



export default studentProfilePage;